import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import Footer from "../ones/Footer";
import MembershipAuthModal from "../ones/MembershipAuthModal";

export default function MembershipLanding(props) {
  const appContext = useContext(AppContext);
  /* Place states here */
  const [ready, setReady] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);

  async function init() {
    //run initializations here
    setReady(false);
    //..

    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (ready) {
    return (
      <>
        <section
          className="page-hero text-white"
          style={{
            backgroundImage:
              "linear-gradient(120deg, rgba(18,60,140,0.92), rgba(18,60,140,0.62))",
          }}
        >
          <div className="container py-5">
            <div className="row align-items-center">
              <div className="col-lg-8" data-aos="fade-up">
                <p className="about-tag bg-light text-dark d-inline-flex align-items-center mb-3">
                  Join TEF
                </p>
                <h1 className="font-bold display-5 mb-3">Membership</h1>
                <p className="lead mb-0">
                  Become part of a professional editorial network committed to ethical journalism and media freedom.
                </p>
              </div>

              {!appContext.auth? (
                <div className="col-lg-4 text-lg-end mt-4 mt-lg-0">
                  <button className="btn btn-rounded btn-light btn-padded shadow-sm btn-login" onClick={() => {
                    setShowAuthModal(true);
                    }}>
                    Login / SignUp
                  </button>
                  <MembershipAuthModal show={showAuthModal} onClose={() => setShowAuthModal(false)} />
                </div>
              ): (
                <div className="col-lg-4 text-lg-end mt-4 mt-lg-0">
                  <button className="btn btn-rounded btn-light btn-padded shadow-sm btn-login" onClick={() => {appContext.logoutMember()}}>
                    Logout
                  </button>
                </div>
              )}
              
            </div>
          </div>
        </section>
        <Footer />
      </>
    );
  } else {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }
}
